import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SnRegistryGaurd } from './registry.gaurd';

// TODO JS clean up modules

const routes: Routes = [
  {
    path: 'camera-registry',
    loadChildren: () =>
      import('@app/fusus-registry/camera-registry').then((m) => m.CameraRegistryModule),
  },

  {
    path: 'signup/:phone',
    loadChildren: () =>
      import('@app/fusus-registry/camera-registry').then((m) => m.CameraRegistryModule),
  },
  {
    path: 'stats',
    loadChildren: () =>
      import('@app/fusus-registry/camera-counter').then((m) => m.CameraCounterModule),
  },
  {
    path: 'validate-email',
    canActivate: [SnRegistryGaurd],
    loadChildren: () =>
      import('@app/fusus-registry/validate-email').then((m) => m.ValidateEmailModule),
  },
  {
    path: '',
    canActivate: [SnRegistryGaurd],
    loadChildren: () =>
      import('@app/fusus-registry/camera-registry').then((m) => m.CameraRegistryModule),
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
